import { createUrl } from 'src/feature/common/utils/url';
import { makeAsyncCall } from 'src/utils';
import { BACKEND_URL } from 'src/constants';
import { StorageService } from './StorageService';

const getDocumentGroups = ({ filter, sort }, page, per_page) =>
  makeAsyncCall({
    url: createUrl('survey-document-groups', filter, sort, per_page, page, undefined),
    method: 'GET',
  });

const handleGetDocumentQuestions = (documentId, participantGroupId) =>
  makeAsyncCall({
    url: `${BACKEND_URL}participant-groups/${participantGroupId}/survey-documents/${documentId}/questions`,
    method: 'GET',
  });

const handleGetDocumentGroup = (documentGroupId: number) =>
  makeAsyncCall({
    url: `${BACKEND_URL}survey-document-groups/${documentGroupId}`,
    method: 'GET',
  });

const handleSortDocumentGroups = documentGroups =>
  makeAsyncCall({
    url: `${BACKEND_URL}survey-document-groups/sort`,
    method: 'PUT',
    body: JSON.stringify(documentGroups),
  });

// @deprecated use src/feature/api/service/implementations/SurveyDocumentGroupsService SurveyDocumentGroupsService.save
const handleSave = documentGroup => {
  if (documentGroup.preview_img_url) {
    return StorageService.uploadFile(documentGroup.preview_img_url).then(uploadPath => {
      return makeAsyncCall({
        url: `${BACKEND_URL}survey-document-groups${
          documentGroup.id ? `/${documentGroup.id}` : ''
        }`,
        method: documentGroup.id ? 'PUT' : 'POST',
        body: JSON.stringify({
          ...documentGroup,
          upload_path: uploadPath,
        }),
      });
    });
  } else {
    return makeAsyncCall({
      url: `${BACKEND_URL}survey-document-groups${
        documentGroup.id ? `/${documentGroup.id}` : ''
      }`,
      method: documentGroup.id ? 'PUT' : 'POST',
      body: JSON.stringify({
        ...documentGroup,
        ...(documentGroup.id && documentGroup.delete_prev_img
          ? { upload_path: null }
          : {}),
      }),
    });
  }
};

const remove = documentGroupId =>
  makeAsyncCall({
    url: `${BACKEND_URL}survey-document-groups/${documentGroupId}`,
    method: 'DELETE',
  });

export const DocumentGroupService = {
  index: (
    { filter, sort }: { filter: object; sort?: string },
    page?: string | number,
    per_page?: number
  ) => getDocumentGroups({ filter, sort }, page, per_page),
  getDocumentContentQuestions: (documentId: number, participantGroupId: number) =>
    handleGetDocumentQuestions(documentId, participantGroupId),
  getDocumentGroup: (documentGroupId: number) => handleGetDocumentGroup(documentGroupId),
  sortDocumentGroups: documentGroups => handleSortDocumentGroups(documentGroups),
  saveDocumentGroup: documentGroup => handleSave(documentGroup),
  remove: documentGroupId => remove(documentGroupId),
};
